"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const organisms_1 = require("../../organisms");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const PreferencesServiceProvider_1 = require("../../providers/PreferencesServiceProvider");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
function Preferences() {
    const { isMobile } = (0, device_1.usePlatform)();
    const preferences = (0, PreferencesServiceProvider_1.usePreferencesService)();
    const { t } = (0, i18n_1.useTranslation)();
    (0, ui_1.usePageTitle)(t(i18n_1.Strings.pageTitle.preferences));
    (0, react_1.useEffect)(() => {
        preferences.fetch();
    }, [preferences]);
    return ((0, jsx_runtime_1.jsx)(bridge_1.BridgeProvider, { "data-e2e": 'Preferences_BridgeProvider', children: (0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'Preferences_Container', children: (0, jsx_runtime_1.jsx)(ui_1.ScrollView, { "data-e2e": 'Preferences_ScrollView', children: (0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'Preferences_Content', children: [(0, jsx_runtime_1.jsx)(ui_1.DndProvider, { "data-e2e": 'Preferences_DndProvider', children: (0, jsx_runtime_1.jsx)(organisms_1.InfoBoxTabsRearrangeSection, { "data-e2e": 'Preferences_InfoBoxTabsRearrangeSection' }) }), !isMobile && (0, jsx_runtime_1.jsx)(organisms_1.AppActiveFeatures, { "data-e2e": 'Preferences_AppActiveFeatures' }), (0, jsx_runtime_1.jsx)(organisms_1.AdditionalPreferences, { "data-e2e": 'Preferences_AdditionalPreferences' })] }) }) }) }));
}
exports.PreferencesPage = (0, PreferencesServiceProvider_1.withPreferencesService)(Preferences);
const Container = styled_components_1.default.div `
  height: 100%;
  overflow-y: auto;

  box-sizing: border-box;

  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);

  background: ${({ theme }) => theme.designSystem.background};

  user-select: none;

  ${ui_1.styledScrollbar};
`;
const Content = styled_components_1.default.div `
  margin: 0;
  padding-bottom: 20px;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    max-width: 1300px;
    padding: 0 32px;
    margin: 0 auto;
  `)}
`;
